import React from 'react'
import { Language } from './data/types'
import { categories } from './data'
import { webviewCategories } from './data/webviewData'
import LanguageToggle from './LanguageToggle'
import DocTypeSelector, { DocType } from './DocTypeSelector'

interface DocsNavigationProps {
    currentLanguage: Language
    onLanguageChange: (lang: Language) => void
    activeSection: string
    onSectionClick: (sectionId: string) => void
    docType: DocType
    onDocTypeChange: (type: DocType) => void
}

const DocsNavigation: React.FC<DocsNavigationProps> = ({
    currentLanguage,
    onLanguageChange,
    activeSection,
    onSectionClick,
    docType,
    onDocTypeChange
}) => {
    const currentCategories = docType === 'api' ? categories : webviewCategories

    return (
        <div className="docs-sidebar">
            <div className="docs-sidebar-header">
                <h1 className="docs-sidebar-title">EmpreX {docType === 'api' ? 'API' : 'Webview'}</h1>
                <p className="docs-sidebar-subtitle">
                    {docType === 'api'
                        ? (currentLanguage === 'pt' ? 'Documentação da API' : 'API Documentation')
                        : (currentLanguage === 'pt' ? 'Documentação do Webview' : 'Webview Documentation')
                    }
                </p>
            </div>

            <DocTypeSelector currentType={docType} onTypeChange={onDocTypeChange} />

            <LanguageToggle currentLanguage={currentLanguage} onLanguageChange={onLanguageChange} />

            <nav className="docs-nav">
                {currentCategories.map((category) => (
                    <div key={category.id} className="docs-nav-section">
                        <h3 className="docs-nav-section-title">{category.title[currentLanguage]}</h3>
                        <a
                            href={`#${category.id}`}
                            className={`docs-nav-item ${activeSection === category.id ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault()
                                onSectionClick(category.id)
                            }}
                        >
                            {currentLanguage === 'pt' ? 'Visão Geral' : 'Overview'}
                        </a>
                        {category.endpoints.map((endpoint) => (
                            <a
                                key={endpoint.id}
                                href={`#${endpoint.id}`}
                                className={`docs-nav-item ${activeSection === endpoint.id ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault()
                                    onSectionClick(endpoint.id)
                                }}
                            >
                                <span className="nav-endpoint-title">{endpoint.title[currentLanguage]}</span>
                                <span className={`nav-method-badge ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span>
                            </a>
                        ))}
                    </div>
                ))}
            </nav>
        </div>
    )
}

export default DocsNavigation
